import React from "react";
import Sidebar from "@/components/Sidebar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main className="lg:pl-[260px]">
        <div className="p-4 sm:p-6 lg:p-8 max-w-[1500px] mx-auto">{children}</div>
      </main>
    </div>
  );
}
